import moment from 'moment';
import utf8 from 'utf8';
import base64 from 'base-64';

function generate_key( ) {
  var date = moment( new Date() ).format( 'YYYYMMDDHHmmssSSS' );
  var bytes = utf8.encode( date );
  var encoded = base64.encode( bytes );
  return encoded;
}

export function alert_push( type, title, message, timeout ) {

  const actual_timeout = timeout === undefined ? 0 : timeout;

  let action_type = 'NOTIFICATION_INFO';

  if( type.toString().toLowerCase() === 'warning' ) {
    action_type = 'NOTIFICATION_WARNING';
  }

  if( type.toString().toLowerCase() === 'critical' ) {
    action_type = 'NOTIFICATION_CRITICAL';
  }

  if( type.toString().toLowerCase() === 'success' ) {
    action_type = 'NOTIFICATION_SUCCESS';
  }
  return {
    type: action_type,
    payload: {
      type: type,
      title: title,
      message: message,
      timeout: actual_timeout,
      published: moment( new Date() ).format( 'YYYY-MM-DD HH:mm:ss.SSS' ),
      key: generate_key( )
    }
  };
}

export function alert_pop( type, key ) {

  let action_type = 'REMOVE_NOTIFICATION_INFO';

  if( type.toString().toLowerCase() === 'warning' ) {
    action_type = 'REMOVE_NOTIFICATION_WARNING';
  }

  if( type.toString().toLowerCase() === 'critical' ) {
    action_type = 'REMOVE_NOTIFICATION_CRITICAL';
  }

  if( type.toString().toLowerCase() === 'success' ) {
    action_type = 'REMOVE_NOTIFICATION_SUCCESS';
  }

  return {
    type: action_type,
    payload: {
      key: key
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/notifications.js